// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"689":"217bc98e","966":"4db48f5d"}[chunkId] + ".css";
};